export default __webpack_public_path__ + "static/media/023-fish shop.adcb487d.svg";